import React from "react";

import AnimateIconComputer from "../icons/animate-sc-icon-1.jsx";
import AnimateIconDownload from "../icons/animate-sc-icon-2.jsx";
import AnimateIconPhone from "../icons/animate-sc-icon-3.jsx";
import AnimateIconPin from "../icons/animate-sc-icon-4.jsx";

import col1 from "../images/3-col-chart-1.png"
import col2 from "../images/3-col-chart-2.png"
import col3 from "../images/3-col-chart-3.png"
import col1mobile from "../images/3-col-chart-1-mobile.png"
import col2mobile from "../images/3-col-chart-2-mobile.png"
import col3mobile from "../images/3-col-chart-3-mobile.png"

import Calculator from "./Calculator";
import Form from "./Form.jsx";


function SupplyChain() {
  return (
    <div>
      <div className="banner supplychain img-fluid">
        <div className="container m-padding banner-padding">
          <div className="row">
            <div className="col-md-7 col-sm-6"></div>
            <div className="col-md-5 col-sm-6 mb-5">
              <h2 className="preheader fw-bold color-1 compatil-bold">Supply Chain</h2>
              <h1 className="display-3 fw-bold color-1 compatil-bold mb-5">Savings With <span className="color-2">Chlorhexidine</span></h1>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light-grey">
        <div className="container m-padding py-5">
          <div className="row">
            <div className="col-md-1 col-sm-6"></div>
            <div className="col-md-10 col-sm-6">
              <h2 className="text-center color-1 compatil-bold fw-bold desktop">Reduced central line-associated bloodstream infection (CLABSI) incidence may improve patient satisfaction and your health system’s reputation</h2>
              <h2 className="text-center color-1 compatil-bold fw-bold mobile pt-5 pb-5">Reduced central<br></br> line-associated bloodstream infection (CLABSI) incidence may improve patient satisfaction and your health system’s reputation</h2>
            </div>
            <div className="col-md-1 col-sm-6"></div>
          </div>
          <div className="row py-5">
            <div className="col-md-7 col-sm-6">
              <h3 className="compatil-bold fw-bold color-1">What's the patient impact?</h3>
              <h4 className="open-sans min pb-5">When one health system moved away from <strong className="color-1">Arrowg+ard Blue <span className="color-2">Plus</span></strong><sup className="color-2">&trade;</sup> to Vantex CVCs with Oligon material from Medline Industries, LP, the incidence of CLABSI more than doubled. So they switched back.<sup>1</sup></h4>

              {/* 3 col chart */}
              <div className="row chart-container">
                <div className="col-md-4 col-sm-6 text-center no-pad-m pad-m-b">
                  <div className="title-height-container flex-v">
                    <h5 className="open-sans min color-2">Using Arrowg+ard Blue Plus™ CVCs</h5>
                  </div>
                  <img src={col1} alt="" className="chart-icon desktop" />
                  <img src={col1mobile} alt="" className="img-fluid mobile" />
                  <p className="open-sans color-1 no-margin">4 cases</p>
                  <h5 className="open-sans color-2">7/1/2016 – 4/30/2017</h5>
                </div>
                <div className="col-md-4 col-sm-6 text-center no-pad-m pad-m-b">
                  <div className="title-height-container flex-v">
                    <h5 className="open-sans min">After switching to Vantex CVCs with Oligon material</h5>
                  </div>
                  <img src={col2} alt="" className="chart-icon desktop" />
                  <img src={col2mobile} alt="" className="img-fluid mobile" />
                  <p className="open-sans color-1 no-margin">10 cases</p>
                  <h5 className="open-sans color-2">7/1/2017 – 4/30/2018</h5>
                </div>
                <div className="col-md-4 col-sm-6 text-center no-pad-m pad-m-b">
                  <div className="title-height-container flex-v">
                    <h5 className="open-sans min color-2">After switching back to using Arrowg+ard Blue Plus™ CVCs</h5>
                  </div>
                  <img src={col3} alt="" className="chart-icon desktop" />
                  <img src={col3mobile} alt="" className="img-fluid mobile" />
                  <p className="open-sans color-1 no-margin">1 case</p>
                  <h5 className="open-sans color-2">7/30/2018 – 4/30/2019</h5>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 border-left home blue">
              <div className="row">
                <h3 className="compatil-bold fw-bold color-1">What's the economic impact?</h3>
                <h4 className="open-sans min pb-3">Each CLABSI incidence costs a health system $48,108.<sup>2</sup> Small reductions in incidence can lead to significant savings.</h4>
                <Calculator />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-blue pad-m-y pad-m-b">
        <div className="container m-padding py-5">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <h2 className="compatil-bold fw-bold text-white">We've made ordering simple</h2>
              <h4 className="open-sans color-1 mb-5"><strong>To order chlorhexidine protected products for your institution, visit myTeleflex.com.</strong></h4>
              <h4 className="open-sans text-white mb-5"><strong>myTeleflex.com allows you to:</strong></h4>
            </div>
          </div>
          <div className="inline-icon-container row flex-v">
            <div className="col-sm-6 col-md-3 text-center">
              <div className="footer-inline-icon">
                <AnimateIconComputer />
              </div>
              <h4 className="open-sans min text-white mt-3 pad-m-b">Place product<br></br> orders online</h4>
            </div>
            <div className="col-sm-6 col-md-3 text-center">
              <div className="footer-inline-icon">
                <AnimateIconDownload />
              </div>
              <h4 className="open-sans min text-white mt-3 pad-m-b">Access order<br></br> invoices</h4>
            </div>
            <div className="col-sm-6 col-md-3 text-center">
              <div className="footer-inline-icon sm">
                <AnimateIconPhone />
              </div>
              <h4 className="open-sans min text-white mt-3">Find your<br></br> local sales rep</h4>
            </div>
            <div className="col-sm-6 col-md-3 text-center">
              <div className="footer-inline-icon sm">
                <AnimateIconPin />
              </div>
              <h4 className="open-sans min text-white mt-3">Track orders</h4>
            </div>
          </div>
          <div className="row pt-5">
            <div className="btn-container">
              <a href="https://myteleflex.com/" target="_blank" rel="noopener noreferrer">
                <button className="btn btn-primary btn-wide" type="button"><strong>Visit myTeleflex.com</strong></button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Form />
      {/* references */}
      <div className="references container pb-5">
        <div className="row pt-5 ref-text open-sans color-3">
          <p>References:
            <ol>
              <li>Abouleish YZ, Oldfield EC, Marik PE. Comparison of central-line-associated bloodstream infections between central venous catheters lined by combined chlorhexidine and silver sulfadiazine versus silver ionotrophes alone: a before-after-before retrospective study. <i>Infect Control Hosp Epidemiol</i>. 2021;42(2):225-227. doi:10.1017/ice.2020.423</li>
              <li>Agency for Healthcare Research and Quality. Estimating the additional hospital inpatient cost and mortality associated with selected hospital-acquired conditions. AHRQ. November 2017. Accessed December 22, 2023. <a href="https://www.ahrq.gov/hai/pfp/haccost2017-results.html" target="_blank" rel="noopener noreferrer">https://www.ahrq.gov/hai/pfp/haccost2017-results.html</a></li>
            </ol>
          </p>
          <p className="pb-4">Rx Only</p>
          <p>Contraindications:</p>
          <p>Arrowg+ard Catheters are contraindicated for patients with known hypersensitivity to chlorhexidine, silver sulfadiazine and/or sulfa drugs.</p>
          <p>Clinical assessment of the patient must be completed to ensure no contraindications exist. Arrowg+ard Blue Advance™ Catheters are contraindicated in the following areas:</p>
          <p>
            <ul className="no-margin pb-1">
              <li>Patients with known hypersensitivity to chlorhexidine</li>
              <li>In presence of device-related infections</li>
              <li>In presence of previous or current thrombosis in the intended vessel or along the catheterized vessel pathway</li>
            </ul>
          </p>
          <p className="pb-4">No correlation between <i>in vitro/in vivo</i> testing methods and clinical outcomes have currently been ascertained.</p>
          <p className="sm">Teleflex, the Teleflex logo, Arrow, Arrowg+ard Blue, Arrowg+ard Blue Advance, and Arrowg+ard Blue Plus are trademarks of Teleflex Incorporated or its affiliates, in the U.S. and/or other countries. All other trademarks are trademarks of their respective owners. MC-008512</p>
        </div>
      </div>
    </div>
  );
}

export default SupplyChain;
